<template>
    <div :key="'sample' + sample.id" class="mt-2 hover-cell" @click="$emit('selected', sample)">
        <v-card>
            <v-card-text class="pa-2">
                {{ sample.code }}
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    props: {
        sample: {
            type: Object,
            default: null,
        },
    },
};
</script>
<style scoped>
    .hover-cell {
        cursor: pointer;
    }
</style>
